




export default function FinnaHome() {
  return (
  <div>
  <h1>Welcome my lovely Finna!!!!</h1>
  <img  src={`${process.env.PUBLIC_URL}/images/finna_nate_painting.png`} alt="Nate Rengo standing in front of a field" className="profile"></img>

  </div>

  );
}